// Single source for the "How it works" section. AiGenerator renders these as the
// visible step cards and page.js builds the HowTo structured data from the same
// array — Google (and the LLM crawlers reading the same markup) discard HowTo whose
// steps aren't backed by on-page text, so the two must never drift apart.
const HOW_IT_WORKS = [
  {
    id: 'step-1',
    n: 'STEP 01',
    title: 'Describe it',
    text: '“A 270° pressure gauge, 0–10 bar, green-amber-red zones, needle, value in the centre.” Plain words — no XML, no coordinates.',
  },
  {
    id: 'step-2',
    n: 'STEP 02',
    title: 'AI builds & validates',
    text: 'Code composes the tricky geometry (arcs, needles, scales); the AI styles it. Every file is validated so it opens in WinCC Unified.',
  },
  {
    id: 'step-3',
    n: 'STEP 03',
    title: 'Refine by talking',
    text: '“Make the labels bigger”, “change the range to 0–200”. It edits the same widget instead of starting over. First 3 edits are free.',
  },
];

export default HOW_IT_WORKS;
